import React from 'react';

import oneplusLogo from '../Assets/imgs/Oneplus_logo2.png';
import infinixLogo from '../Assets/imgs/Infinix_logo.png';

export default function PartnersSection() {
  return (
    <section id="partners" className="py-20 px-6 bg-gray-100 font-poppins">
      <div className="max-w-5xl mx-auto text-center">
        {/* text-4xl font-semibold mb-4 text-center text-gray-900 */}
        <h3 className="font-poppins text-4xl font-semibold mb-12  text-gray-900">
          Our Partners
        </h3>

        <div className="flex flex-col sm:flex-row sm:justify-center sm:gap-20 gap-12 items-center">
          {/* OnePlus */}
          <div className="flex flex-col items-center">
            <img
              src={oneplusLogo}
              alt="OnePlus Logo"
              className="w-56 sm:w-64 object-contain mb-4"
              loading="lazy"
            />
          </div>

          {/* Infinix */}
          <div className="flex flex-col items-center">
            <img
              src={infinixLogo}
              alt="Infinix Logo"
              className="w-56 sm:w-64 object-contain mb-4"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

// import React from 'react';

// // Import your brand images (adjust paths)
// import oneplusLogo from '../Assets/imgs/Oneplus_logo2.png';
// import infinixLogo from '../Assets/imgs/Infinix_logo.png';

// export default function PartnersSection() {
//   return (
//     <section id="partners" className="py-20 px-6 bg-blue-10 font-poppins">
//       <div className="max-w-5xl mx-auto text-center">
//         <h3 className="font-poppins text-5xl font-semibold mb-12 text-gray-900">
//           Our Partners
//         </h3>

//         <div className="flex flex-col sm:flex-row sm:justify-center sm:gap-20 gap-12 items-center">
//           {/* Oneplus */}
//           <div className="flex flex-col items-center">
//             <img
//               src={oneplusLogo}
//               alt="OnePlus Logo"
//               className="w-40 sm:w-48 object-contain mb-4"
//               loading="lazy"
//             />
//           </div>

//           {/* Infinix */}
//           <div className="flex flex-col items-center">
//             <img
//               src={infinixLogo}
//               alt="Infinix Logo"
//               className="w-40 sm:w-48 object-contain mb-4"
//               loading="lazy"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
